import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { getActiveClientEndpoint as endpoint } from "../apiEndpoint";
import { header } from "../../../context/constant";
const GetActiveClientAPI = async () => {
    const url = endpoint()
    const options: FetchOptions = {
        method: "GET",
        headers: header,
    }
    return fetchInterceptor(url, options)
};
export default GetActiveClientAPI;